"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncIterableStartsWith_ = asyncIterableStartsWith_;

var _asyncToAnySubseq = _interopRequireDefault(require("../../internal/async-to-any-subseq"));

var _asyncZipAll = require("../$zip-all/async-zip-all");

var _asyncWrap = require("../$wrap/async-wrap");

var _slice = require("../$slice/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const noItem = {};
const zipAllConfig = {
  filler: noItem
};

async function asyncIterableStartsWith_(iterable, config, value) {
  const subseqs = await (0, _asyncToAnySubseq.default)(config, value);
  const wrappedSubseqs = subseqs.map(_asyncWrap.asyncWrap);
  const states = subseqs.map(_ => ({
    matches: true,
    done: false
  }));

  for await (const allItems of (0, _asyncZipAll.asyncZipAll)([iterable, ...wrappedSubseqs], zipAllConfig)) {
    const item = allItems[0];
    let i = -1;
    let allDone = true;
    let anyMatched = false;

    for (const subseqItem of (0, _slice.simpleSlice)(allItems, 1, Infinity)) {
      const state = states[++i];
      state.done = subseqItem === noItem;
      state.matches = state.matches && subseqItem === item;
      allDone = allDone && state.done;
      anyMatched = anyMatched || state.matches;
    }

    if (allDone) break;
    if (!anyMatched) return false;
  }

  return true;
}